import styled from 'styled-components'

import { style } from 'theme'

const Note = styled.div`
  background-color: ${style(theme => theme.colors.ivory)};
  border-radius: 8px;
  color: ${style(theme => theme.colors.slate)};
  font-size: 14px;
  line-height: 1.4;
  margin: 0 auto;
  padding: 12px 16px;
  text-align: left;
  width: 100%;
`

export default Note
